import React, { Component } from "react";
import cmsContent from "../../../MiddleWare/CmsContent";
import { Alert } from "reactstrap";
import Datatable from "../../../components/Datatable/Datatable";
import { ACCESS_POINT } from "../../../config";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LoginModal from "../../../components/Modal/Modal";
import swal from "sweetalert";

class AddImage extends Component {
  //defining states
  constructor(props) {
    super(props);
    this.state = {
      file: "",
      url: "",
      errorFile: null,
      value: "",
      btnDisable: false,
      alertVisible: false,
      fileName: "choose File",
      errorHint: null,
      hint: null,
      customerId: localStorage.getItem("userId"),
      userlog: localStorage.getItem("userlog") ? localStorage.getItem("userlog") : {},
      userName: localStorage.getItem("userName") ? localStorage.getItem("userName") : {},
      List: []
    };
  }
  async componentDidMount() {
    try {
      await this.MainFunc()
    } catch (error) {
      console.log(error);
    }
  }
  MainFunc = async () => {
    try {
      const { data: List } = await cmsContent.getFreedom(
        "*",
        "tbl_image",
        `customerId=${this.state.customerId} and storedAt IS NULL`,
        "id",
        "id DESC"
      );
      if (List) {
        this.setState({ List });
      }
    } catch (error) {
      console.log(error);
    }
  }
  //submit validation function
  submit = async () => {
    //alert("submit")
    //e.preventDefault();
    //     let value = this.state.value;
    // console.log(value)
    //     if (value === null || value.trim() === "") {
    //       return false;
    //     }
    const { file, hint } = this.state;
    // console.log(file);
    // console.log(hint);
    //
    if (!file) {
      this.setState({ errorFile: "Select File to Upload" });
      return false;
    } else if (!hint) {
      this.setState({ errorFile: "", errorHint: "Enter Searchable hint" });
      return false;
    } else {
      this.setState({ errorFile: "", btnDisable: true });
      let customerId = this.state.customerId;
      console.log(customerId);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", hint);
      formData.append("customerId", customerId);
      //let groupArray ={};
      //formData.file=value.trim();
      //formData.status="active";
      // formData.customerId=this.state.customer
      ;
      //formData.serviceId=this.state.serviceId;

      try {
        const result = await cmsContent.insertImage(formData, "tbl_image");

        //let result;
        if (result) {
          let valueArray = {};
          // console.log(result);
          // valueArray.type = result.data.type;
          // valueArray.file = result.data.file;
          // valueArray.customerId = result.data.customerId
          // valueArray.file_extension = result.data.file_extension
          await this.MainFunc()
          //valueArray.uploadResult = result.List.insertId;
          //valueArray.formData = value.trim();
          //    console.log(valueArray);
          // const newData = [valueArray, ...this.state.List];
          await this.setState({
            // List: newData,
            file: "",
            errorFile: "",
            hint: "",
            btnDisable: false,
            alertVisible: true,
            fileName: "choose File",
            errorHint: null
          });
          //remove success msg after 3 sec
          setTimeout(() => this.setState({ alertVisible: false }), 3000);
        }
      } catch (error) { }
    }
  };

  //remove success msg
  onDismiss = () => {
    this.setState({ alertVisible: false });
  };

  //onchange event function
  selectImage = e => {
    this.setState({ file: e.target.files[0], fileName: e.target.files[0].name });
  };

  column = [
    {
      Header: "Hint",
      accessor: "type"
    },
    {
      Header: "Link",
      accessor: "file",
      Cell: d => this.fullLink(d)
    },
    {
      id: 'file_extension',
      Header: "Type",
      accessor: d => this.file_extension(d, 1),
      Cell: d => this.file_extension(d, 2)
    },
    {
      Header: "Image",
      accessor: "file_extension",
      Cell: d => this.showimage(d)
    },
    {
      Header: "Copy",
      accessor: "file",
      Cell: d => this.clipBoard(d)
    },
    {
      Header: "Share",
      accessor: "file",
      Cell: d => this.sharelink(d)
    },
    {
      Header: "Delete",
      accessor: "delete",
      Cell: (d) => this.delete(d),
    },
  ];

  sharelink = (d) => {
    return (
      <div>
        <LoginModal
          title="Share Link"
          buttonTitle="Share Link"
          id="customer"
          extraClass="btn btn-warning"
          onClick={() => this.reset(d)}
          bodyText={
            <div >

              <input
                type="text"
                name="searchhint"

                className="form-control"
                value={`${ACCESS_POINT}/cmsContent/getImages/${d.original.file.split("/")[0]}/${d.original.file.split("/")[1]}`}
              />         <br></br>

              <CopyToClipboard
                text={`${ACCESS_POINT}/cmsContent/getImages/${d.original.file.split("/")[0]}/${d.original.file.split("/")[1]}`}
                onCopy={() => this.setState({ copied: true })}
              >
                <button type="button" className="btn btn-primary">
                  Copy to clipboard
                </button>
              </CopyToClipboard>
              <br></br>
              {
                this.state.copied == true && (
                  <div>
                    <span style={{ color: "green" }}>
                      URL is Copied
                    </span>
                  </div>
                )
              }
            </div>

          }
        />
      </div>
    )
  }
  delete = (value) => {
    return (
      <button
        type="button"
        className="btn btn-danger"
        onClick={() => this.buttonDelete(value.original)}
      >
        Delete
      </button>
    );
  };
  buttonDelete = async (d) => {
    if (d && d.id) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Image/File!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then(async (willDelete) => {
          if (willDelete) {
            let result = await cmsContent.library_delete(d.id)
            swal({
              title: `Your Image/File has been deleted!`,
              icon: "success",
              button: {
                text: "Ok",
                closeModal: true,
              },
            }).then(async (willDelete) => {
              if (willDelete) {
                if (result) {
                  await this.MainFunc()
                  swal.close()
                }
                else {
                  swal("Something went wrong. Try Again", {
                    icon: "warning",
                  });
                }

              }
            });
          }
        });
    }
  }
  reset = async (d) => {
    await this.setState({ url: d.original.file, copied: false })
  }
  fullLink = (d) => {
    return `${ACCESS_POINT}/cmsContent/getImages/${d.original.file.split("/")[0]}/${d.original.file.split("/")[1]}`
  }
  file_extension = (d, q) => {
    let org = (q === 1) ? d : d.original;
    let validationImage = ["jpeg", "jpg", "png", "gif"];
    let validationVideo = [
      "ogg",
      "ogv",
      "mpg",
      "mpeg",
      "mp4",
      "mp3",
      "dat",
      "avi"
    ];
    let ImageExtension = org.file_extension.toLowerCase();
    if (validationImage.indexOf(ImageExtension) !== -1) {
      return "Image";
    } else if (validationVideo.indexOf(ImageExtension) !== -1) {
      return "Video";
    } else {
      return "NA";
    }
  };
  clipBoard = d => {
    return (
      <div>
        <CopyToClipboard
          text={`${ACCESS_POINT}/cmsContent/getImages/${d.original.file.split("/")[0]}/${d.original.file.split("/")[1]}`}
          onCopy={() => this.setState({ copied: true })}
        >
          <button type="button" className="btn btn-primary">
            Copy to clipboard
          </button>
        </CopyToClipboard>
      </div>
    );
  };
  showimage = (d) => {
    let validationImage = ["jpeg", "jpg", "png", "gif", "svg"];
    let validationVideo = [
      "ogg",
      "ogv",
      "mpg",
      "mpeg",
      "mp4",
      "mp3",
      "dat",
      "avi"
    ];
    let ImageExtension = d.original.file_extension.toLowerCase();
    if (validationImage.indexOf(ImageExtension) !== -1) {
      return (
        <img src={`${ACCESS_POINT}/cmsContent/getImages/${d.original.file.split("/")[0]}/${d.original.file.split("/")[1]}`} style={{ width: 25, height: 25 }} />
        // <img src={`${ACCESS_POINT}/superAdmin/sharefile?filename=${d.original.file}`} style={{ width: 25, height: 25 }} />
      )
    } else if (validationVideo.indexOf(ImageExtension) !== -1) {
      return "Video";
    } else {
      return "NA";
    }


  }
  //rendering
  render() {
    //using state values to render and return
    const { errorFile, btnDisable, alertVisible, hint, errorHint } = this.state;

    return (
      <React.Fragment>
        <main className="main my-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h3>Add File</h3>
                  </div>
                  <div className="card-body" />

                  <div>
                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-7">
                        <Alert
                          className="badge-content"
                          color="success"
                          isOpen={alertVisible}
                          toggle={this.onDismiss}
                        >
                          File Uploaded Successfully
                        </Alert>
                      </div>
                      <div className="col-sm-3" />
                    </div>
                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-2">
                        <label for="exampleInputEmail1">Upload File</label>
                      </div>
                      <div className="col-sm-5 custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="customFile"
                          onChange={this.selectImage}
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="customFile"
                        >
                          {this.state.fileName}
                        </label>
                      </div>
                      <div className="col-sm-3" />
                    </div>
                    <div className="row form-group">
                      <div className="col-sm-4" />
                      <span className="error-show ">{errorFile}</span>
                    </div>

                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-2">
                        <label for="exampleInputEmail1">Search Hint</label>
                      </div>
                      <div className="col-sm-5 custom-file">
                        <input
                          type="text"
                          name="searchhint"
                          placeholder="Enter  hint"
                          className="form-control"
                          onChange={e =>
                            this.setState({ hint: e.target.value })
                          }
                          value={this.state.hint}
                        />
                      </div>
                      <div className="col-sm-3" />
                    </div>
                    <div className="row form-group">
                      <div className="col-sm-4" />
                      <span className="error-show ">{errorHint}</span>
                    </div>

                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-2" />
                      <div className="col-sm-5">
                        <button
                          type="button"
                          class="btn btn-primary"
                          disabled={btnDisable}
                          onClick={this.submit}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-sm-3" />
                    </div>
                    <div className="row form-group">
                      <div className="col-sm-12">
                        {this.state.List ? (<Datatable
                          data={this.state.List}
                          columnHeading={this.column}
                        />) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
export default AddImage;
